import React from "react";
import { Footer, LCGNav } from "../components";
import { Container, Form, Button, Row } from "react-bootstrap";

const ContactPage = () => {
  const sendEmail = (fName, lName, email, msg) => {};

  return (
    <div>
      <div className="wrapper">
        <LCGNav />
        <Container>
          <Form
            className="center"
            onSubmit={(e) => {
              e.preventDefault();
              const fName = document.getElementById("first_name").value;
              const lName = document.getElementById("last_name").value;
              const email = document.getElementById("email").value;
              const msg = document.getElementById("msg").value;
              alert("Coming Soon!");
            }}>
            <Row>
              <Form.Group className="mb-3 w-50">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter first name"
                  id="first_name"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3 w-50">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter first name"
                  d="last_name"
                  required
                />
              </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                id="email"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={4} required id="msg" />
            </Form.Group>
            <Button variant="dark" type="submit" className="w-100">
              Submit
            </Button>
          </Form>
        </Container>
      </div>
      <Footer />
    </div>
  );
};
export default ContactPage;
